interface ProjectType {
  name: string;
  description: string;
  url: string;
}

const projects: Array<ProjectType> = [
  {
    name: "Infer-No-079",
    description: "Our first game Jam game on itch.io and ranked 47th worldwide",
    url: "https://colespy.itch.io/infer-no079",
  },
  {
    name: "WolfBoy",
    description: "A GameBoy Emulator Written in C++",
    url: "https://github.com/Rudranil-Sarkar/WolfBoy",
  },
  {
    name: "PAW OS",
    description: "A operating system made from stracth",
    url: "https://github.com/Rudranil-Sarkar/PAW-OS",
  },
  {
    name: "Ordered Dithering Shader",
    description: "A dithering shader made in GLSL",
    url: "https://github.com/Rudranil-Sarkar/Ordered-Dithering-Shader-GLSL",
  },
  {
    name: "Ray Tracer",
    description: "A Simple Ray Tracer in C++",
    url: "https://github.com/Rudranil-Sarkar/Simple_Ray_Tracer",
  },
];

const Project: React.FC<ProjectType> = ({ name, description, url }) => {
  return (
    <a href={url} className="Project" target="_blank" rel="noreferrer">
      <h3 className="Project-Name">{name}</h3>
      <h4>{description}</h4>
    </a>
  );
};

const AboutMe = () => {
  return (
    <div className="AboutMe-Card-Container">
      <div className="Drag-WindowTitle">BIO DATA</div>
      <div className="StatusBar-Container">
        <h3>XYZ</h3>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <h4>SIGNAL LOW</h4>
        </div>
      </div>
      <div className="Designation-Container">
        <div>
          <h3>DEVELOPER</h3>
          <h1>L D5-1.5</h1>
        </div>
        <h5 style={{ textAlign: "right" }}>
          ACCESS <br />
          ***********
        </h5>
      </div>
      <div className="Image-WithBio-Container">
        <div className="Image-Container">
          <img draggable={false} src="/images/me2.png" alt="" />
        </div>
        <div className="Info">
          <h3>RUDRANIL SARKAR</h3>
          <ul>
            <li>
              <a href="mailto:rudronil34@gmail.com">rudronil34@gmail.com</a>
            </li>
            <li>
              <a
                href="https://twitter.com/tastyjammy"
                target="_blank"
                rel="noreferrer"
              >
                [ twitter ]
              </a>
            </li>
            <li>
              <a
                href="https://github.com/Rudranil-Sarkar"
                target="_blank"
                rel="noreferrer"
              >
                [ github ]
              </a>
            </li>
            <li>
              <a
                href="https://www.linkedin.com/in/rudranil-sarkar-150744159/"
                target="_blank"
                rel="noreferrer"
              >
                [ linkedin ]
              </a>
            </li>
          </ul>
          <h4>VERIFIED....</h4>
        </div>
      </div>
      <div className="AboutText">
        [ X ] Never been the best guy when it comes to academics
        <br />
        [ X ] Love to solve problems and learn new things
        <br />[ X ] Love retro computers and old tech
      </div>
      <div className="Skills-Container" style={{ padding: "0.1em" }}>
        <h2>[+] SKILLS</h2>
        <ul>
          <li>C/C++</li>
          <li>PYTHON</li>
          <li>JAVASCRIPT</li>
          <li>TYPESCRIPT</li>
          <li>REACT</li>
          <li>NODE</li>
          <li>LINUX</li>
        </ul>
      </div>
      <div className="Projects-Container">
        <h2>[+] PROJECTS</h2>
        <div className="Projects-List">
          {projects.map((elt, index) => (
            <Project
              name={elt.name}
              key={index}
              description={elt.description}
              url={elt.url}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default AboutMe;
